import React from 'react';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { Dots } from "react-activity";
import Select from 'react-select';

const ReasignModal = ({
  setExecutive,
  toggle,
  submit,
  loading,
  isOpen,
  values,
}) => {

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className='crm-modal-gestion-container crm-modal-reasign'
    >
      <ModalHeader toggle={toggle}>
        Reasignación de Cotización
        <div className="af-gold-line" />
      </ModalHeader>
      <form onSubmit={submit}>
        <ModalBody>
          <div className='crm-reasign-container'>
            <div className='crm-reasign-info'>
              <span className='crm-reasign-field'>Cotización:</span>
              <span className='crm-reasign-data'><strong>ID:</strong> {values.code}</span>
            </div>
            <div className='crm-reasign-info'>
              <span className='crm-reasign-field'>Ejecutivo Actual:</span>
              <span className='crm-reasign-data'>{values.userData}</span>
            </div>
            <div className='crm-reasign-transfer'>
              <label id="executive">Ejecutivo a Transferir:</label>
              <Select
                options={values.users}
                type="text"
                name="executive"
                placeholder="seleccione"
                id="executive"
                isDisabled={loading}
                onChange={(e) => { setExecutive(e); }}
                required
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="crm-modal-cancel-btn"
            type="button"
            onClick={toggle}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="crm-modal-accept-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? <Dots /> : 'Transferir'}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default ReasignModal;